import { defineMessages } from 'react-intl';

export const AUTH_INVALID_USERNAME_PASSWORD = 'AUTH_INVALID_USERNAME_PASSWORD';

export const messages = defineMessages({
  cancel: {
    id: 't.cancel',
    defaultMessage: 'Cancel',
  },
  help: {
    id: 't.help',
    defaultMessage: 'Help',
  },
  community: {
    id: 't.community',
    defaultMessage: 'Community',
  },
  signUp: {
    id: 't.signUp',
    defaultMessage: 'Sign Up',
  },
  login: {
    id: 't.login',
    defaultMessage: 'Log In',
  },
  logout: {
    id: 't.logout',
    defaultMessage: 'Log Out',
  },
  viewPlans: {
    id: 't.viewPlans',
    defaultMessage: 'View Plans',
  },
  continue: {
    id: 't.continue',
    defaultMessage: 'Continue',
  },
  invalidEmail: {
    id: 't.invalidEmail',
    defaultMessage: 'Invalid email',
  },
  shouldBeValidEmail: {
    id: 't.shouldBeValidEmail',
    defaultMessage: 'Email must be a valid email',
  },
  emailIs: {
    id: 't.emailIs',
    defaultMessage: 'Email: {email}',
  },
  alreadyRegistered: {
    id: 't.alreadyRegistered',
    defaultMessage: 'Thank you. You have already registered with Pandora.',
  },
  alreadySignedIn: {
    id: 't.alreadySignedIn',
    defaultMessage: 'You are already logged in!',
  },
  resetPasswordLogOut: {
    id: 't.resetPasswordLogOut',
    defaultMessage: 'To reset your password, please log out.',
  },
  ZIP_CODE_INVALID: {
    id: 't.ZIP_CODE_INVALID',
    defaultMessage: 'Invalid ZIP code',
    field: 'zipcode',
  },
  hasPandoraAccount: {
    id: 't.hasPandoraAccount',
    defaultMessage: 'Already have a Pandora account? {link}',
  },
  signUpFree: {
    id: 't.signUpFree',
    defaultMessage: 'Sign up for free',
  },
  subscription: {
    id: 't.subscription',
    defaultMessage: 'Subscription',
  },
} as const);
